import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import {
  buildSentryTracePropagationTargets,
  hydratePortalSentryUserFromStorage,
  initPortalSentry,
  setPortalSentryTag,
} from '@admin-panel/observability';

import App from './app/Application';
import { BrowserRouter } from 'react-router';
import { installPackingNavigationGuard } from '@admin-panel/pages/orders/packages/usePackingNavigationGuard';

import { ensureDeviceFingerprint, getDeviceFingerprint } from '@admin-panel/utils';
import './styles/main.css';

const tracePropagationTargets = buildSentryTracePropagationTargets(
  import.meta.env.VITE_GATEWAY_API_URL,
);

initPortalSentry(tracePropagationTargets);

const bootstrap = async () => {
  installPackingNavigationGuard();
  await ensureDeviceFingerprint();
  setPortalSentryTag('device_id', getDeviceFingerprint());
  hydratePortalSentryUserFromStorage();
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
};

void bootstrap();

window.setTimeout(() => {
  void import('./app/registerFirebaseServiceWorker').then(
    ({ registerAdminFirebaseServiceWorker }) => registerAdminFirebaseServiceWorker(),
  );
}, 0);
